/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Generated by vite-plugins/prodeng-routes.ts
 * Source: content/prodeng/2025-12-23_why-great-products-are-built-in-the-tradeoffs.md
 */

import { createFileRoute } from '@tanstack/react-router';
import { ProdEngArticleLayout } from '@/components/ProdEngArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/prodeng/why-great-products-are-built-in-the-tradeoffs.mdx';

const metadata = {
  title: "Why Great Products Are Built in the Tradeoffs, Not the Backlog",
  date: "2025-12-23",
  author: "Christian Battaglia",
  articleNumber: 1,
  seoDescription: "Most product failures aren't technical or about talent; they're failures of decision-making. Learn the Fast/Good/Well framework for making intentional tradeoffs instead of optimizing backlogs.",
  linkedinUrl: "https://www.linkedin.com/pulse/why-great-products-built-tradeoffs-backlog-christian-battaglia-lwy3e",
  heroImage: "/prodeng/why-great-products-are-built-in-the-tradeoffs.webp",
  readTime: "2 min read",
  tags: ["product engineering","tradeoffs","decision-making","product management","engineering leadership","backlog","software engineering","product strategy"],
  published: true,
};

export const Route = createFileRoute('/prodeng/articles/why-great-products-are-built-in-the-tradeoffs')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title} — Product Engineering`,
    description: metadata.seoDescription || '',
    path: '/prodeng/articles/why-great-products-are-built-in-the-tradeoffs',
    image: '/og/prodeng/why-great-products-are-built-in-the-tradeoffs.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    authorName: metadata.author,
    readTime: metadata.readTime,
    tags: metadata.tags,
    section: 'Product Engineering',
  }),
});

function ArticlePage() {
  return (
    <ProdEngArticleLayout {...metadata}>
      <Content />
    </ProdEngArticleLayout>
  );
}
